<template>
<span v-text='formatName($root.user)'></span>
</template>

<script>
export default {
    props: [
    ],
    data: function(){
        return {
        };
    },
    methods: {
    }
}
</script>
